import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { FunctionColor, Preset } from '@lux/text';
import { TitlePreset } from '@lux/title';
import { Translate, TranslateScope } from '@pegasus/translation';
import { CardsSkeletonLoader } from '@browsing/components';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Carousel } from './carousel';
import * as S from './styles';
import { useTopPick4U } from './use-top-pick4U';
import { ErrorCard } from './error-card';
import { topPicksTracker } from './tracking';
export var TopPicks4U = function (_a) {
    var isMobileScreen = _a.isMobileScreen, gender = _a.gender, isOmnibusRrpExperiment = _a.isOmnibusRrpExperiment, omnibusPolandOrItaly = _a.omnibusPolandOrItaly;
    var _b = useTopPick4U(gender), topPics4U = _b[0], loading = _b[1], error = _b[2];
    var titlePreset = isMobileScreen ? TitlePreset.S : TitlePreset.M;
    var _c = useState(false), inView = _c[0], setInView = _c[1];
    var trackFirstSeeAllClick = function () {
        topPicksTracker.track('seeAll_first_TP4U', {
            component: 'TP4U_showstopper',
            isTP4U: 1,
        });
    };
    var onViewChange = function (isInView) {
        if (isInView) {
            topPicksTracker.track('view_item_tp4u', {
                component: 'TP4U_showstopper',
            });
            setInView(isInView);
        }
    };
    return (React.createElement(TranslateScope, { path: "myLounge.TP4U" },
        React.createElement(InView, { as: "div", onChange: onViewChange, triggerOnce: true },
            React.createElement(S.TopPicksContainer, null,
                React.createElement(S.DetailsWrapper, null,
                    React.createElement(S.DetailsContainer, { onClick: trackFirstSeeAllClick, href: "/campaigns/top-picks/articles" },
                        React.createElement(S.StyledHeadline, { preset: titlePreset, color: FunctionColor.function0 },
                            React.createElement(Translate, { message: "headline" })),
                        React.createElement(S.StyledCaption, { preset: Preset.M, color: FunctionColor.function0 },
                            React.createElement(Translate, { message: "caption" })),
                        React.createElement(S.StyledTextLink, null,
                            React.createElement(Button, { buttonType: ButtonType.tertiary, color: ButtonColor.bright },
                                React.createElement(Translate, { message: "cta" }))))),
                React.createElement(S.CarouselWrapper, null,
                    loading && (React.createElement(S.CardLoaderWrapper, null,
                        React.createElement(CardsSkeletonLoader, { width: 185, itemsCount: 6, cardHeight: 320 }))),
                    !loading && !error && (React.createElement(Carousel, { carouselItems: topPics4U, isInView: inView, isOmnibusRrpExperiment: isOmnibusRrpExperiment, omnibusPolandOrItaly: omnibusPolandOrItaly })),
                    error && React.createElement(ErrorCard, null))))));
};
